<ng-template [vbCssRules]="cssRules" [id]="'sidebar-styles'"></ng-template>

<div [ngClass]="styles.sidebarButtonContainer">
	<div [ngClass]="styles.sidebarButtons" class="vb-scrollbar" role="tablist" tabindex="0" (focus)="onFocusButtons($event)" [attr.aria-label]="'SideBarMenu' | translate">
		<ng-content select="[slot='sidebarButtons']"></ng-content>
	</div>
</div>

<div flex="fill" role="tabpanel" [attr.layout-lt-md]="disableMobileLayout ? null : 'column'" [class.open]="isOpen()" [class.noBorder]="noBorder" [ngClass]="[
		styles.sidebarPanel,
		enableAnimation ? styles.transitionWidth : ''
	]" [style.width]="isOpen() && openWidthPx ? openWidthPx + 'px' : ''">
	<div [attr.flex-lt-md]="disableMobileLayout ? null : 'fill'" layout="column" layout-wrap="false" [ngClass]="styles.sidebarPanelLayout" [style.width]="isOpen() && openWidthPx ? openWidthPx + 'px' : ''">

		<header layout="row" layout-wrap="false" [ngClass]="styles.header">
			<div flex="fill" class="d-flex justify-content-between">
				<div>
					@if (activeButton()?.headerLabel) {
						<span>{{ activeButton()?.headerLabel }}</span>
					}
					<ng-content select="[slot='headerTitle']"></ng-content>
				</div>
				<ng-content select="[slot='headerControls']"></ng-content>
			</div>

			@if(!closeBtnHidden) {
				<button type="button" class="margin-left-10 btn btn-transparent" [attr.aria-label]="'Event_CloseSidebarPanel' | translate" (click)="closeSidebar()">
					<span class="glyphicons remove_2"></span>
				</button>
			}
		</header>

		<div *ngIf="isOpen()" flex="fill" flex-align="center" class="vb-scrollbar" [ngClass]="styles.sidebarPanelBody" ui-view="sidebar">
			<ng-content select="[slot='panelBody']"></ng-content>
		</div>
	</div>
</div>
